<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-company-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-action-bar
          v-on:update:search="searchQuery = $event"
          v-on:update:deleted="showDeleted = $event"
          title="Entities"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: 'company.create' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create Entity</span>
          </span>
        </vs-dropdown-item>
        <vs-dropdown-item v-if="componentAccess.canEdit.access">
          <span
              class="flex items-center"
              @click="downloadExport"
          >
            <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Download Entity CSV</span>
          </span>
          </vs-dropdown-item>
      </grid-action-bar>

      <!-- AgGrid Table -->
      <t-grid
          :column-defs="columnDefs"
          class="lg"
          :data="data"
          :loading="loading"
          :search="searchQuery"
          auto-size
          @rowClicked="onRowClicked"
      />

    </div>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import router from "../../../router";
import api from '@/api';

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import GridActionBar from "@/views/components/extra-components/GridActionBar";
import CellRendererVerified from "../../components/ag-grid/cell-renderer/CellRendererVerified";
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import FileDownloadMixin from "@/components/mixins/FileDownloadMixin";

export default {
  components: {
    TGrid,
    vSelect,
    YesNoToggle,
    GridActionBar,
    CellRendererVerified,
    // Cell Renderer
  },
  mixins: [
    FileDownloadMixin,
    CanAccessMixin,
  ],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,
      componentAccess: {
        canCreate: {
          route: 'company.create',
          access: false,
        },
        canEdit: {
          route: 'company.edit',
          access: false,
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Entity Name',
          field: 'CompanyName',
          filter: 'agTextColumnFilter',
          minWidth: 150,
          sort: 'asc',
        },
        {
          headerName: 'Entity Code',
          field: 'CompanyCode',
          filter: 'agTextColumnFilter',
          minWidth: 140,
        },
        {
          headerName: 'Reporting Group',
          field: 'CompanyGroupName',
          filter: 'agTextColumnFilter',
          minWidth: 170,
        },
        {
          headerName: 'Entity Classification',
          field: 'EntityType',
          filter: 'agTextColumnFilter',
          minWidth: 190,
        },
        {
          headerName: 'Sales Country',
          field: 'salesCountryType',
          filter: 'agTextColumnFilter',
          minWidth: 170,
        },
        {
          headerName: 'No. of Contacts',
          field: 'NumContacts',
          filter: 'agTextColumnFilter',
          minWidth: 160,
          comparator: this.numberSort
        },
        {
          headerName: 'No. of Users',
          field: 'NumUsers',
          filter: 'agTextColumnFilter',
          minWidth: 150,
          comparator: this.numberSort
        },
        {
          headerName: 'Primary Email',
          field: 'PrimaryEmailAddress',
          filter: 'agTextColumnFilter',
          minWidth: 160,
        },
        {
          headerName: 'Primary Phone Number',
          field: 'PrimaryPhoneNumber',
          filter: 'agTextColumnFilter',
          minWidth: 210,
        },
        {
          headerName: 'Is Active',
          field: 'IsEnabled',
          minWidth: 130,
          cellRenderer: 'CellRendererVerified',
        },
        {
          headerName: 'Contains Active Users',
          field: 'ContainsActiveUsers',
          minWidth: 130,
          cellRenderer: 'CellRendererVerified',
        },
        {
          headerName: 'Contains Fides Users',
          field: 'ContainsFidesUsers',
          minWidth: 130,
          cellRenderer: 'CellRendererVerified',
        },
      ],

      loading: false,
      data: [],
    }
  },
  watch: {
    showDeleted(value) {
      this.list({IsDeleted: value | 0});
    }
  },
  mounted () {
    this.list({IsDeleted: 0});
  },
  methods: {
    numberSort(num1, num2) {
      return num1 - num2;
    },
    updateSearchQuery (val) {
      this.searchQuery = val;
    },
    async onRowClicked({data}) {
      const route = 'company';

      if (await this.canAccessRoute(route, false)) {
        router.push({ name: route, params: { id: data.id }}).catch(() => {});
      }
    },
    async list(params = {}) {
      try {
        this.loading = true;
        const { data } = await this.$api.companies.all({params});
        this.data = data.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async downloadExport() {
      const response = await api.get('/companies/download-csv/');

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "entities.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
}

</script>

<style lang="scss">
#page-company-list {
  .company-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
